import React from 'react';
import tableImg from "../../../../shared/image/dev/goods.png";
import styled from "styled-components";
import {GLOBAL_STYLE_CONFIG} from "../../../../app/styles/GlobalStyles";

const StyledPreviewGoods = styled.div`


    img {
        max-width: 100%;
        max-height: 100%;
    }
`;
const PreviewGoods = () => {
    return (
        <StyledPreviewGoods className={GLOBAL_STYLE_CONFIG.splitByPrefix('card-media-preview')}><img src={tableImg} alt=""/></StyledPreviewGoods>
    );
};

export default PreviewGoods;